import { render, staticRenderFns } from "./left-nav.vue?vue&type=template&id=327e386e&scoped=true&lang=pug&"
import script from "./left-nav.vue?vue&type=script&lang=js&"
export * from "./left-nav.vue?vue&type=script&lang=js&"
import style0 from "./left-nav.vue?vue&type=style&index=0&id=327e386e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e386e",
  null
  
)

export default component.exports